import React, { useEffect } from 'react';
import { META_DESCRIPTION, META_PIXEL_ID, PAGE_TITLE } from './data/content';
import { bonusCovers, heroMockupUrl, offerMockupUrl, pageImages } from './data/images';
import { initMetaPixel } from './utils/metaPixel';
import { TopBar } from './components/TopBar';
import { Hero } from './components/Hero';
import { StatsBand } from './components/StatsBand';
import { BeforeAfter } from './components/BeforeAfter';
import { MeetingSelector } from './components/MeetingSelector';
import { LookInsideSection } from './components/LookInsideSection';
import { SolutionSection } from './components/SolutionSection';
import { SkillsBand } from './components/SkillsBand';
import { YearPlanSection } from './components/YearPlanSection';
import { MeetingsList } from './components/MeetingsList';
import { CoordinatorSection } from './components/CoordinatorSection';
import { BonusesSection } from './components/BonusesSection';
import { OfferSection } from './components/OfferSection';
import { GuaranteeSection } from './components/GuaranteeSection';
import { FaqSection } from './components/FaqSection';
import { FinalCta } from './components/FinalCta';
import { Footer } from './components/Footer';
import { StickyCta } from './components/StickyCta';
const pixelNoscript = META_PIXEL_ID ? `<img height="1" width="1" style="display:none" alt="" src="https://www.facebook.com/tr?id=${META_PIXEL_ID}&ev=PageView&noscript=1" />` : '';
export function App() {
  useEffect(() => {
    document.title = PAGE_TITLE;
    let meta = document.querySelector<HTMLMetaElement>('meta[name="description"]');
    if (!meta) {
      meta = document.createElement('meta');
      meta.name = 'description';
      document.head.appendChild(meta);
    }
    meta.content = META_DESCRIPTION;
    initMetaPixel();
  }, []);
  return <div id="top" className="min-h-screen w-full overflow-x-hidden bg-white font-sans text-ink antialiased" data-id="element-0" data-mp="nur8c681cizz">
      {pixelNoscript && <noscript dangerouslySetInnerHTML={{
      __html: pixelNoscript
    }} data-id="element-1" data-mp="swqajcs1h9vc" />}
      <TopBar data-id="element-2" data-mp="356rh3pi3e8j" />
      <main data-id="element-3" data-mp="34nbvtnbp1xo">
        <Hero heroMockupUrl={heroMockupUrl} data-id="element-4" data-mp="38ktgau95lfg" />
        <StatsBand data-id="element-5" data-mp="3udkn7x6lywax" />
        <BeforeAfter data-id="element-6" data-mp="3ubzw6hji5vht" />
        <MeetingSelector data-id="element-7" data-mp="3uevs60bsia3m" />
        <LookInsideSection pageImages={pageImages} data-id="element-8" data-mp="d4e5zu7z1ex8" />
        <SolutionSection data-id="element-9" data-mp="d45tw4joadn3" />
        <SkillsBand data-id="element-10" data-mp="d2bj3j2481wq" />
        <YearPlanSection data-id="element-11" data-mp="85ujnspgu14c" />
        <MeetingsList data-id="element-12" data-mp="86mev2f5hwu3" />
        <CoordinatorSection data-id="element-13" data-mp="864d5q9pyqes" />
        <BonusesSection bonusCovers={bonusCovers} data-id="element-14" data-mp="83qdf443gq0w" />
        <OfferSection offerMockupUrl={offerMockupUrl} data-id="element-15" data-mp="3gm63tp8sgt3c" />
        <GuaranteeSection data-id="element-16" data-mp="3bmbazg5gdtfn" />
        <FaqSection data-id="element-17" data-mp="3bn314bga6yyj" />
        <FinalCta data-id="element-18" data-mp="3bnuv5hu8comp" />
      </main>
      <Footer data-id="element-19" data-mp="3bkgss9lkgff9" />
      <StickyCta data-id="element-20" data-mp="3qaxrvmaqat8z" />
    </div>;
}